export default {
  // エラーメッセージ
  MSG_ERROR_SYTEM:
    'システムエラーが発生しました。システム管理者にご連絡をお願いします。\n' +
    ' 詳細)\n ',
  MSG_ERROR_SESSION:
    'サーバとの接続が切断されたためログアウトします。\n' + ' 詳細)\n ',
  MSG_ERROR_SESSION_DETAIL: 'ログイン処理を行ってください。',
  // 警告メッセージ
  MSG_WARN_LOGIN_ERROR:
    'ログイン名もしくはパスワードが違います。\n' +
    ' ご確認の上、再度、ログイン情報を入力してください。',
  MSG_WARN_LOGIN_CLOSING:
    'Hitonobiの使用期限が切れているため、ログインできません。',
  MSG_WARN_DATE_ERROR:
    '表示開始日は表示終了日と同じ、または表示終了日以前の日付を指定してください',
  MSG_WARN_SHOWO_ORDER_ERROR: 'aには数値を入力してください。',
  MSG_WARN_RANKING_MAX_ERROR:
    '絞り込み期間に該当するプラスの氣がa件を超えています。\n' +
    ' a件を超えるとプラスの氣の表示処理でHitonobiのサーバーに負荷がかかり、\n' +
    ' エラーが発生しやすい状況となってしまいます。\n\n' +
    ' お手数をおかけしますが、絞り込み結果がa件以内に収まるよう、\n' +
    ' 絞り込みの期間などを短くして頂きますようお願いします。',
  // 情報メッセージ
  NOT_FOUND:
    'データの取得に失敗しました。URLが不正、または削除されたアイテムの可能性があります',
  MSG_INFO_MEMBER_NOT_FOUND: 'プラスの氣を送信するスタッフの情報がありません。',
  MSG_INFO_MANAGE_MEMBER_NOT_FOUND:
    '条件に一致したスタッフの情報がありません。',
  MSG_INFO_ORGANIZATION_NOT_FOUND: '組織情報がありません。',
  MSG_INFO_SEARCH_ORGANIZATION_NOT_FOUND:
    '条件に一致した組織情報がありません。',
  MSG_INFO_POSITION_NOT_FOUND: '役職情報がありません。',
  MSG_INFO_IMGTYPE_ERROR:
    'アップロードできる画像ファイルの形式は「jpeg」か「png」のみです。',
  MSG_INFO_IMGSIZE_ERROR:
    'アップロードできる写真のサイズは150KBまでです。\n' +
    ' お手数をおかけしますが、容量の小さいサイズの写真を選択してください。',
  MSG_INFO_AVATER_ENPTY:
    '画像が選択されていません。画像を選択後、アップロードしてください。',
  MSG_INFO_AVATER_COMPLETE: '画像サムネイルの登録が成功しました。',
  MSG_INFO_SEND_PURASUNOKI_COMPLETE: 'さんへのプラスの氣の送信が成功しました。',
  MSG_INFO_SEND_REPLY_MESSAGE_COMPLETE:
    'さんへの返信メッセージの送信が成功しました。',
  MSG_INFO_DELETE_PURASUNOKI_COMPLETE:
    'さんへのプラスの氣の削除が成功しました。',
  MSG_INFO_DELETE_REPLY_MESSAGE_COMPLETE:
    'さんへの返信メッセージの削除が成功しました。',
  MSG_INFO_PURASUNOKI_ENPTY:
    'プラスの氣が入力されていません。入力後、プラスの氣を送ってください。',
  MSG_INFO_PURASUNOKI_MIN_STRING: 'プラスの氣は「a」文字以上入力してください。',
  MSG_INFO_PURASUNOKI_EMOJI_STRING:
    '絵文字の入力は禁止しています。\n' +
    ' 恐れ入りますが、絵文字以外の入力をお願いします。',
  MSG_INFO_STAFF_ENTRY_COMPLETE: 'さんのスタッフ情報登録が成功しました。',
  MSG_INFO_STAFF_ENTRY_COMPLETE_JINJI:
    'さんのスタッフ情報登録が成功しました。\n\n' +
    ' 登録したスタッフ情報でログインするには、\n' +
    ' 等級管理ボタンからスタッフ等級設定を行ってください。',
  MSG_INFO_STAFF_DELETE_COMPLETE: 'さんのスタッフ情報削除が成功しました。',
  MSG_INFO_OWNER_ORGANIZE_ENTRY_COMPLETE: '様の組織情報登録が成功しました。',
  MSG_INFO_OWNER_ORGANIZE_DELETE_COMPLETE: '様の組織情報削除が成功しました。',
  MSG_INFO_ORGANIZE_ENTRY_COMPLETE: '組織情報の変更が成功しました。',
  MSG_INFO_PASSWORD_ENTRY_COMPLETE:
    'パスワードの変更が成功しました。\n' +
    ' ログイン画面から変更したパスワードでログインしてください。',
  MSG_INFO_GRADE_ENTRY_COMPLETE: '等級情報の登録が成功しました。',
  MSG_INFO_GRADE_DELETE_COMPLETE: 'の等級情報削除が成功しました。',
  MSG_INFO_DEPARTMENT_ENTRY_COMPLETE: '部署情報の登録が成功しました。',
  MSG_INFO_DEPARTMENT_DELETE_COMPLETE: 'の部署情報削除が成功しました。',
  MSG_INFO_POSITION_ENTRY_COMPLETE: '役職情報の登録が成功しました。',
  MSG_INFO_POSITION_DELETE_COMPLETE: 'の役職情報削除が成功しました。',
  MSG_INFO_ACTEMT_ENTRY_COMPLETE: '行動要素の登録が成功しました。',
  MSG_INFO_ACTEMT_DELETE_COMPLETE: 'の行動要素削除が成功しました。',
  MSG_INFO_RANK_ENTRY_COMPLETE: 'ランク設定の登録が成功しました。',
  MSG_INFO_RANK_DELETE_COMPLETE: 'のランク設定削除が成功しました。',
  MSG_INFO_USERGRADE_ENTRY_COMPLETE: 'スタッフ等級情報の登録が成功しました。',
  MSG_INFO_USERGRADE_DELETE_COMPLETE: 'のスタッフ等級情報削除が成功しました。',
  MSG_INFO_PERIOD_DELETE_COMPLETE: 'の年度情報削除が成功しました。',
  MSG_INFO_EVALUATION_DELETE_COMPLETE: 'さんの評価情報削除が成功しました。',
  MSG_INFO_GOAL_ACTION_ENTRY_COMPLETE: '行動要素情報の更新が成功しました。',
  MSG_INFO_GOAL_ACTION_DELETE_COMPLETE: '行動要素情報の削除が成功しました。',
  MSG_INFO_GOAL_ENTRY_COMPLETE: 'の更新が成功しました。',
  MSG_INFO_GOAL_DELETE_COMPLETE: 'の削除が成功しました。',
  MSG_INFO_GOAL_EVAL_ENTRY_COMPLETE: '評価の更新が成功しました。',
  MSG_INFO_GOAL_CHALLENGE_ENTRY_COMPLETE:
    'チャレンジ情報の更新が成功しました。',
  MSG_INFO_GOAL_CHALLENGE_DELETE_COMPLETE:
    'チャレンジ情報の削除が成功しました。',
  MSG_INFO_SYSOP_LOGININFO_UPDATE_COMPLETE:
    'システムオーナーログイン情報の変更が成功しました。',
  MSG_INFO_TOPRANKING_NOT_FOUND:
    'トップランキングを表示できるプラスの氣がありません。\n' +
    ' プラスの氣を検索後に、トップランキングを表示してください。',
  MSG_INFO_NICE_TWO_NG: '「いいね！」は一つのコメントにつき、一回までです。',
  MSG_INFO_NICE_SELF_NG: '自分が送信したプラスの氣に「いいね！」はできません。',
  MSG_INFO_PURASUNOKI_LIST_MAX:
    'プラスの氣の件数がa件を超えました。\n' +
    ' 日付の新しい順からa件までのプラスの氣を表示します。',
  MSG_INFO_LOGINID_ALREADY_EXISTS:
    '入力されたメールアドレスは既に存在しています。\n' +
    ' 違うメールアドレスを入力してください。',
  MSG_INFO_ORGANIZATION_KEY_ALREADY_EXISTS:
    '入力された組織キーは既に存在しています。\n' +
    ' 違う組織キーを入力してください。',
  MSG_INFO_SYSOP_LOGINID_ALREADY_EXISTS:
    '入力されたシステムオペレーターのメールアドレスは既に存在しています。\n' +
    ' 違うメールアドレスを入力してください。',
  MSG_INFO_OWNER_LOGINID_ALREADY_EXISTS:
    '入力されたシステムオーナーのメールアドレスは既にHitonobiで使用されています。\n' +
    ' 違うメールアドレスを入力してください。',
  MSG_INFO_ALREADY_UPLOAD_FILE: '「a」は既にアップロードされています。',
  MSG_INFO_POSSIBLE_UPLOAD_FILE: '「a」はアップロードできません。',
  MSG_INFO_BULK_ENTRY_COMPLETE: '様の情報の一括登録が成功しました。',
  MSG_INFO_ACT_ENTRY_NG:
    '6つの行動要素が全て入力されているので、行動要素を新規追加できません。\n' +
    '表示されている行動要素を編集するか、削除してから新規追加を行ってください。',
  MSG_INFO_CHG_ENTRY_NG:
    '4つの目標が全て入力されているので、目標を新規追加できません。\n' +
    '表示されている目標を編集するか、削除してから新規追加を行ってください。',
  MSG_INFO_TOTAL_GOAL_TITLE_LENGTH_NG: 'aは全角50文字以内で入力してください。',
  MSG_INFO_TASK_TITLE_LENGTH_NG: 'aは全角20文字以内で入力してください。',
  MSG_INFO_TOTAL_GOAL_ENTRY_LENGTH_NG: 'aは全角500文字以内で入力してください。',
  MSG_INFO_TASK_CONTENT_LENGTH_NG: 'aは全角100文字以内で入力してください。',
  MSG_INFO_EVALUATION_NO_DATA:
    '自己・一次評価のデータが削除されたため、評価処理を継続できません。\n' +
    ' 管理者様にお問合せください。',
  MSG_ACT_EMT_SELF_SCORE_NO_ENTRY:
    'の自己評価が入力されていません。\n' + ' 自己評価を入力して下さい。',
  MSG_ACT_EMT_FIRST_SCORE_NO_ENTRY:
    'の一次評価が入力されていません。\n' + ' 一次評価を入力して下さい。',
  MSG_BULK_PROGRAM_RUNNING:
    '評価に関するプログラムが実行中です。\n' +
    ' しばらく時間が経過した(最大15分)後に実行をお願いします。',
  // 一括登録処理メッセージ
  // スタッフ評価作成
  MSG_INFO_BULK_ENTRY_EVALUATION_COMPLETE:
    'スタッフ様の評価情報作成処理を開始しました。\n' +
    ' 本処理は画面と並行して動作するプログラムで実行されるため、\n' +
    ' データ数によっては最大15分程度かかります。\n\n' +
    ' しばらく経過した後、スタッフ評価設定画面で年度、部署、優先順位に\n' +
    ' 該当するデータを検索し、評価データが作成されることを確認してください。\n\n' +
    ' なお、本処理では、既に登録されている評価データの更新処理は行いません。',

  // スタッフ評価削除
  MSG_INFO_BULK_DELETE_EVALUATION_COMPLETE:
    'スタッフ様の評価情報削除処理を開始しました。\n' +
    ' 本処理は画面と並行して動作するプログラムで実行されるため、\n' +
    ' データ数によっては最大15分程度かかります。\n\n' +
    ' しばらく経過した後、スタッフ評価設定画面で年度、部署、優先順位に\n' +
    ' 該当するデータを検索し、評価データが削除されることを確認してください。\n\n' +
    ' なお、本処理では、登録されている該当の評価データを全て削除します。',

  // 評価開始
  MSG_INFO_BULK_START_EVALUATION_COMPLETE:
    'の評価開始処理を開始しました。\n' +
    ' 本処理は画面と並行して動作するプログラムで実行されるため、\n' +
    ' データ数によっては最大15分程度かかります。\n\n' +
    ' しばらく経過した後、評価対象のスタッフ様にTODOが送信され、\n' +
    ' 自己評価が開始できることを確認してください。',

  // 評価複製
  MSG_INFO_BULK_COPY_PERIOD_COMPLETE:
    '年度複製処理を開始しました。\n' +
    ' 本処理は画面と並行して動作するプログラムで実行されるため、\n' +
    ' データ数によっては最大15分程度かかります。\n\n' +
    ' しばらく経過した後、スタッフ評価設定画面で年度、部署、優先順位に、\n' +
    ' 該当するデータを検索し、評価データが複製されていることを確認してください。',

  // 等級評価更新
  MSG_INFO_BULK_UPDATE_GOAL_GRADE_COMPLETE:
    '等級評価の評価情報更新処理を開始しました。\n' +
    ' 本処理は画面と並行して動作するプログラムで実行されるため、\n' +
    ' データ数によっては最大15分程度かかります。\n\n' +
    ' しばらく経過した後、スタッフ評価設定画面で年度、部署、優先順位（等級）に\n' +
    ' 該当するデータを検索し、評価データが更新されることを確認してください。\n\n' +
    ' なお、本処理では、既に登録されている評価データにのみ更新処理を行います。',

  // 年度情報更新
  MSG_INFO_BULK_PERIOD_UPDATE_COMPLETE:
    '年度情報更新処理を開始しました。\n' +
    ' 本処理は画面と並行して動作するプログラムで実行されるため、\n' +
    ' データ数によっては最大15分程度かかります。\n\n' +
    ' しばらく経過した後、スタッフ評価設定画面で年度、部署、優先順位に、\n' +
    ' 該当するデータを検索し、年度情報が更新されていることを確認してください。',
};
